import {playVideo, initElements} from '../define/shared'
import Swiper from 'swiper'
import {EffectFade, Autoplay} from 'swiper'
import {refreshScrollTrigger} from '../elements/reveal'

Swiper.use([EffectFade, Autoplay])

const TYPICAL_ASPECT_RATIO = 16/9

export default function initSplashBlocks() {
    initElements('.wab-splash', initSplashBlock)
}

/**
 * @param {HTMLElement} root
 */
export function initSplashBlock(root) {

    initElements({ root, selector: '.b-media > .b-video'}, videoEl => {
        const [ videoId, provider ] = [videoEl.dataset.id, videoEl.dataset.provider]
        const container = videoEl.querySelector('.b-video-inner')
        if (provider && videoId) {
            playVideo(container, {
                videoId,
                provider,
                background: true,
            }).then(() => {
                videoEl.classList.add('is--loaded')
            })
        }

        adjustSize()
        window.addEventListener('resize', adjustSize)
        window.addEventListener('orientationchange', adjustSize)

        function adjustSize() {
            const outerRatio = videoEl.offsetWidth / videoEl.offsetHeight
            const scale = outerRatio / TYPICAL_ASPECT_RATIO
            container.style.transform = `scale(${outerRatio > TYPICAL_ASPECT_RATIO ? scale : 1/scale})`
        }
    })

    initElements({ root, selector: '.sw-slider'}, sliderEl => {

        const videoHandlers = []

        let anyVideoActiveState = null

        const slider = new Swiper(sliderEl, {
            loop: false,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                // pauseOnMouseEnter: true,
            },
            // navigation: {
            //     prevEl: prevSlideBtnEl,
            //     nextEl: nextSlideBtnEl,
            // },
        })

        document.addEventListener('click', event => {
            if (!sliderEl.parentElement.contains(event.target) && !isAnyVideoActive()) {
                slider.autoplay.start()
            }
        })

        sliderEl.addEventListener('mouseleave', event => {
            if (!isAnyVideoActive()) {
                slider.autoplay.start()
            }
        })
        slider.on('slideChangeTransitionEnd', refreshScrollTrigger)

        slider.on('slideChange', event => {
            videoHandlers.forEach(handler => handler.pause())
        })

        initElements({ root: sliderEl, selector: '.b-video' }, videoEl => {
            const [ videoId, provider ] = [videoEl.dataset.id, videoEl.dataset.provider]
            const btn = videoEl.querySelector('.b-video-playBtn')
            const container = videoEl.querySelector('.b-video-inner')

            if (provider && videoId) {
                btn.addEventListener('click', event => {
                    videoEl.classList.add('is--initialized')
                    playVideo(container, {
                        videoId: videoEl.dataset.id,
                        provider: videoEl.dataset.provider,
                        background: false,
                    }).then(initVideoHandler)
                }, { once: true })
            }
        })

        function isAnyVideoActive() {
            return anyVideoActiveState === 'playing' || anyVideoActiveState === 'buffering'
        }

        function initVideoHandler(handler) {
            videoHandlers.push(handler)
            handler.onPlayStateChange(state => {
                anyVideoActiveState = state
                console.log(state)
                if (state === 'playing' || state === 'buffering') {
                    slider && slider.autoplay.stop()
                }
                switch (state) {
                    case 'playing':
                    case 'buffering':
                        root.classList.add('is--playingVideo')
                        break
                    default:
                        root.classList.remove('is--playingVideo')
                }
            })
        }
    })
}
